
import { STORE_SOLACE_CREDENTIALS } from '../actions/storeSolaceCredentialsActions';

export let storeSolaceCredentialSelector =  (state: any) => {
    return state[STORE_SOLACE_CREDENTIALS];
  };